var map = {
	"./Home": [
		1965,
		965
	],
	"./Home/": [
		1965,
		965
	],
	"./Home/index": [
		1965,
		965
	],
	"./Home/index.tsx": [
		1965,
		965
	],
	"./PrivacyPolicy": [
		2643,
		643
	],
	"./PrivacyPolicy/": [
		2643,
		643
	],
	"./PrivacyPolicy/index": [
		2643,
		643
	],
	"./PrivacyPolicy/index.tsx": [
		2643,
		643
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;